export const getHashPath = () => {
  let hash = window?.location?.hash || '';

  if (hash) {
    hash = hash.split('#/')[1] || '';
  }

  return hash;
}
